export const index = {
  // 简体文中
  head: {
    cart: "购物车",
    list: "清单",
    msg: "信息",
    mine: "个人",
    login: "登入",
    register: "注册"
  },
  foot: {
    shop: "商城",
    about: "关于我们",
    news: "新闻中心",
    cooperation: "加盟合作",
    contact: "联络我们",
    privacy: "私隐政策说明",
    conditions: "一般性条款和细则",
    questions: "常见问题"
  },
  address:{
    surname: "姓",
		name: "名",
		inputName2:"请输入收货人名字",
		inputSurname:"请输入收货人姓氏",
		address1: "地址1",
		address2: "地址2(选填)",
		inputAddress2:"请输入街道名称和编号",
		inputAddress3:"请输入楼宇编号/名称/街道名称",
		inputAddress4:"街道/道路名称/辖区",
		postCode: "邮政编码",
		inputPostCode: "请输入邮政编码",
    notAddress:"您还没有设置默认送货地址，请添加后继续结算",
    addressee:"收件人",
    title:"称呼",
    mr: '先生',
    ms: '女士',
    phoneNumber:"联系方式",
    detailedAddress:"详细地址",
    next:"下一步",
    shippingAddress:"送货地址",
    addAddress:"新增地址",
    defaultAddress:"默认地址",
    edit:"编辑",
    delete:"删除",
    setDefaultSuccess:"设置默认成功",
    pleaseRecipient:"请输入收件人",
    pleaseRecipient20:"收件人姓名请设置在20位内",
    pleaseContact :"请输入联系方式",
    pleaseArea: "请选择正确的地址",
    regionSelectionProvince:"地区选择省",
    regionSelectionCity:"地区选择市",
    regionSelectionArea:"地区选择区",
    pleaseDetailAddress:"请输入详细地址",
    pleaseCode:"请输入邮编",
    pleaseCodeTip:"请输入邮编(请填写0000)",
    code:"邮编",
    editSuccess:"修改成功",
    addSuccess:"添加成功",
  },
  account:{
    info:"账户信息",
    setOldPassword:"旧密码",
    setPassword: "设定密码 *(请输入6-10单元，包含字母、数字)",
    setNewPassword:"设定新密码",
    changePassword:"修改密码",
    setNickname:"设置昵称",
    pleaseNickname:"请输入昵称",
    pleasePassword:"请输入新密码",
    nickname:"昵称",
    setAvatar:"设置头像",
    avatar:"头像",
    ok:"确定",
    setAvatarSuccess:"设置头像成功",
    editNicknameSuccess:"修改昵称",
    setNicknameSuccess:"修改昵称成功",
    pleasePasswordSuccess:"新密码设置成功",
    sureExit:"确定退出吗?",
    tips:"提示",
    exit:"退出成功!",
    exitText: '退出',
  },
  login: {
    emailAddress:"电邮地址*",
    emailAddressNot:"电邮地址",
		guestLog: "免登入购物",
    youxing:"邮箱",
    code:"验证码",
    ResendSeconds:"秒后重发",
    getCode:"获取验证码",
    password:"密码",
    pleaseEmail:"请输入邮箱",
    pleaseCode:"请输入验证码",
    pleasePassword:"请输入密码",
    editSuccess:"修改成功",
    sendSuccess:"发送成功",
    PleaseMobileNumberAddress:"请输入手机号码/电邮地址",
    pleaseLastName:"请输入姓氏",
    LastName50: "请输入小于50个字符的姓氏",
    name50: "请输入小于50个字符的名字",
    pwd20: "请输入小于20个字符的密码",
    pleaseName:"请输入名字",
    pleasePhoneNumber:"请输入手机号码",
    pleaseEmailAddress:"请输入电邮地址",
    pleaseRightEmailAddress:"请输入正确电邮地址",
    title: "欢迎来到海马牌床褥",
    phone: "手机号码/电邮地址",
    login: "登入",
    pass: "登入密码",
    account: "未有账户？",
    now: "立即登记",
    forget: "忘记密码",
    register: "注册新账户",
    success: "完成",
    surname: "姓氏 * ",
    name: "名字 * ",
    tel: "手机号码 *",
    setPassword: "设定密码 *(请输入6-10单元，包含字母、数字)",
    email: "电邮地址（可选）",
    agree: "我已阅读并同意",
    policy: "《用户注册协议及私隐政策》",
    tickAgree: "请勾选协议"
  },
  tab: {
    page: "商城首页",
    classification: "商城分类",
    center: "新闻中心",
    cooperation: "加盟合作",
    about: "关于我们",
    contact: "联络我们"
  },
  pageSubtitle: {
    t1: "为你推荐",
    t2: "今日热卖",
    t3: "更多热门推荐",
    t4: "感谢祭震撼优惠价",
    t5:"感谢祭震撼优惠价"
  },
  contact: {
    title: "联络我们",
    store: "门店地址",
    city: "门店地区",
    type: "门店类型",
    county: "门店地域",
    plaCounty: "请选择门店所在地域",
    plaCity: '请选择门店所在地区',
    plaType: '请选择门店类型',
    self: '自营门店',
    franchise: '加盟店',
    null: "暂无门店信息",
    tips: "敬请咨询，我们将竭诚为您服务！",
    words: "在线留言",
    weChat: 'AI在线客服',
    clickWords: "点击页面进入留言",
    telSubtitle: "点击联系客服 WhatsApp",
    telWhatsApp: "客服 WhatsApp",
    telTitle: "服务电话：",
    telNumber: "400 888 888",
    service: "人工服务时间：",
    serviceTimer: "工作日9:00~18:00",
    emailTitle: "电子邮件",
    email: "邮箱：",
    emailNumber: "XXXXX@XXX.XXX",
    emailTips: "请随时给我们发送电子邮件，我们会及时给您答复",
    submit: "保存提交",
    clickWeChat: "点击联系AI客服"
    // userName:"请输入您的姓名",
    // telephone:"请输入联繫电话",
    // telephoneRight:"请输入正确联繫电话",
    // email:"请输入电邮地址",
    // emailRight:"请输入正确电邮地址",
    // content:"请输入您留言的内容",
    // success:"提交成功"
  },
  about: {
    title: "关于我们",
    tab1: "公司介绍",
    tab2: "发展历程",
    tab3: "荣获殊荣",
    aboutTitle:"七海化工集团自1987年创立“海马牌”，从事生产、批发及零售床褥、枕头、床上用品、沙发及各款北欧实木家俬。集团总部设于香港，全球拥有2个生产基地、5个物流中心及100多间自资专门店、员工达1500人；业务遍布香港、中国内地、澳门、新加坡、加拿大、英国、澳洲及马来西亚等地。1987年，“海马牌” 以首创独有配方研制出高品质的“健康床褥”面世，翌年即取得香港销售冠军，扭转弹簧床褥垄断的地位。其后推出的记忆、高回弹床褥、枕头系列，畅销全球。至今，海马牌已成为泛亚地区知名品牌。"
  },
  apply: {
    title: "申请加盟",
    name: "姓 名",
    inputName: "请输入您的姓名",
    tel: "电 话",
    telephone:"请输入联繫电话",
    telephoneRight:"请输入正确联繫电话",
    inputTel: "请输入联繫电话",
    email: "电 邮",
    inputEmail: "请输入电邮地址",
    emailRight:"请输入正确电邮地址",
    area: "地 区",
    success:"提交成功",
    applySuccess:"申请成功",
    inputArea: "请输入申请加盟地区",
    submit: "提交申请",
    textarea: "请输入您留言的内容"
  },
  news: {
    title: "新闻中心",
    read: "阅读全文",
    news: "企业新闻",
    media: "媒体报到",
    temArticleTitle: "试睡活动规则",
    HKpromotion: "中国香港促销",
    promotion: "中国促销",
    overseas: "海外促销",
  },
  classify: {
    null: "暂无分类",
    bedding: "床褥",
    hair: "梳发",
    furniture: "傢私",
    pillow: "枕头",
    custom: "订造傢私",
    projects: "特别项目",
    article: "床上用品",
    hot: "热卖商品"
  },
  info: {
    account: "我的账户",
    settings: "一般设定",
    seek: "寻求协助",
    more: "更多信息",
    orderRecord: "订单记录",
    guestOrder: "游客订单",
    refund: "退款退货",
    coupon: "电子优惠券",
    information: "账户资料",
    address: "送货地址",
    review: "商品评论",
    notice: "优惠资讯通知",
    language: "语言切换",
    novice: "新手攻略",
    vip: "VIP会员计划",
    problem: "常见问题",
    promotion: "招商加盟",
    contact: "联络我们",
    privacy: "私隐政策说明",
    conditions: "一般性条款及细则"
  },
  message: {
    read:"已读",
    system: "系统讯息",
    notification: "讯息通知",
    reminder: "发货提醒",
    payment: "付款成功",
    refund: "退款退货",
    customer: "客服讯息",
    unread: "未读",
    sendGoods: "发货提醒",
    issued: "您的订单已出库",
    detail: "讯息详情",
    msgLoading: '验证码正在发送',
    click: '请勿重复点击',
  },
  cart: {
    market: '市场价',
    shopping: "购物车",
    subtotal: "商品小计",
		conflict: "因所选商品配送时段冲突，请分单购买",
		pickupTips: "因所选商品自提门店冲突，请分单购买",
    express: "运费合计",
    promotional: "促销优惠",
    total: "购物车合计",
    immediate: "立即结算",
    color: "颜       色:",
    price: "单       价:",
    number: "数       量:",
    selectAll: "全选",
    noGoodsShoppingCart: "购物车没有货品，即前往选择钟意商品",
    go: "前往选购"
  },
  del: {
    tips: "确认要删除吗？",
    ok: "确定",
    remind:"提醒",
    cancel: "取消",
    delSuccess:"删除成功",
    pleaseSelect:"请选择商品",
    affirm:"确认收货吗？",
    receivedSuccess:"收货成功",
  },
  goods:{
    refund:"退货退款",
    orderTime:"下单时间:",
    orderNo:"下单编号: ",
    remainingTime:"剩馀支付时间",
    size:"尺寸规格:",
    common: "共",
    piece: "件",
    refunding:"退款中",
    color: "颜    色:",
    refundDetails:"退款详情",
    go: "前往选购",
    noOrder: "暂无订单信息",
    orderNumber:"订单编号",
    refundCode:"退款编码",
    refundReason:"退款原因",
    cargoDamage:"货物损坏",
    refundAmount:"退款金额",
    applicationStatus:"申请状态",
    waitingApplication:"等待申请",
    special: "特价",
    sold: "已售",
    best: "热销货品",
    size: "尺寸规格",
    color: "货品颜色",
    number: "数       量",
    add: "加入购物车",
    list: "加入我的清单",
    special: "特殊订造",
    detail: "详细介绍",
    review: "商品评论"
  },
  order: {
    refund: '退款',
    cancelRefund: '取消退款',
    order: "个人订单",
    all: "全部",
    pending: "待付款",
    shipped: "待发货",
    received: "待收货",
    commented: "待评论",
    time: "下单时间:",
    no: "下单编号:",
    writeComments: "写评论",
    cancellation: "取消订单",
    common: "共",
    piece: "件",
    color: "颜    色:",
    paymentTime: "剩余支付时间",
    size: "尺寸规格:",
    go: "前往选购",
    noOrder: "暂无订单信息",
    score: "产品评分",
    sayScore: "请说说使用评价吧！",
    confirmReceipt:"确认收货",
    continuePay:"继续支付",
    deleteOrder:"删除订单",
    refundOnly :"仅退款",
    refundTips:"没有收到货，货与卖家协商同意不用退货仅退款",
    returnRefund:"退货退款",
    goodsReturned:"已收到货，需要退换货物",
    cargoStatus:"货物状态",
    pleaseSelect:"请选择",
    refundReason:"退款原因",
    refundAmount:"退款金额",
    numberApplications:"申请件数",
    replenish:"补充原因和凭证",
    pleaseRefundReason:"请输入退款原因",
    saveSubmit:"保存提交",
    pleaseSelectCargoStatus:"请选择货物状态",
    PleaseSelectRefundReason:"请选择退款原因",
    refundReturnOption:"退款退货选择",
    commentSuccess:"评论成功",
    cancelSuccee:"取消退款成功",
    sureCancelRefund:"确认取消退款吗？",
    sureDeleteOrder:"确认删除订单吗？",
    sureCancelOrder:"确认取消订单吗？",
    CancelSuccess:"取消成功",
    pickupText1: '送货订单',
    pickupText2: '自提订单',
    pickupText3: '待自提',
    pickupText4: '已取货',
    pickupText5: '确认提货',
    pickupText6: '提货前请务必与店员当面核对商品，确认无误后再点击“确认提货”，确认后视为已提货完成'
  },
  orderDetail: {
    orderReceived: "订单待收货",
    size: "尺寸规格:",
    color: "颜       色:",
    price: "单       价:",
    number: "数       量:",
    receiptInfo: "收货信息",
    consignee: "收货人:",
    contactNumber: "联繫电话：",
    shippingAddress: "收货地址：",
    orderNo: "订单编号:",
    orderTime: "下单时间:",
    subtotalGoods: "商品小计",
    promotional: "促销优惠",
    confirm: "确认收货",
  },
  orderStatusTxt:{
    cancel: "已取消",
    pay: "待支付",
    sendGoods: "待发货",
    received: "待收货",
    evaluated: "待评价",
    completed: "已完成",
    refunded: "已退款",
    refundFailed: "退款失败",
    cancel: "已取消",
    cancel: "已取消",
  },
  statusTxt:{
    cancel: "已取消",
    refundProcessing: "退款处理中",
    refundProcessing: "退款处理中",
    refunded: "已退款",
    refundRejected: "退款已拒绝",
  },
  goodsDeatil:{
    overview:"商品简介：",
    specialPrice:"特价",
    pickup: '支持门店自提',
    pickupTitle: '该商品可自提的门店',
    length:"长度",
    PleaseLength:"请输入内容长度",
    width:"宽度",
    pleaseWidth:"请输入内容宽度",
    height:"高度",
    price:"价格：",
    lengthMust:"长度必须大于0",
    widthMust:"宽度必须大于0",
    addListSuccess:"成功加入我的清单!",
    addshoppingSuccess:"成功加入购物车!",
    sold:"已售",
    dimensions:"尺寸规格",
    itemColor:"货品颜色",
    number:"数量",
    addCart:"加入购物车",
    buyNow: "立即购买",
    addList:"加入我的清单",
    info:"详细介绍：",
    userReviews:"商品评论",
    allUserReviews:"全部商品评论",
    comments:"则评论",
    writeComments:"写评论",
    hotGoods:"热销货品",
    specialOrder:"特殊订造",
    pleaseSelect:"请选择",
    size:"尺码",
    unit:"（单位：英呎）",
    height:"高度",
    color:"颜色",
    score: "产品评分",
    delivery: '送货/退货',
    sayScore: "请说说使用评价吧！"
  },
  goodsConfirmOrder:{
    title: "送货信息",
    addressee:"收件人",
    replace:"更换送货信息",
    color: "颜       色:",
    receiptInfo: "收货信息",
    consignee: "收货人:",
    dimensions:"尺寸规格",
    shippingAddress: "收货地址：",
    goodsList:"商品清单",
    deliveryTime:"送货时间",
    deliveryTimePlease:"请选择送货时间",
    deliveryTimePlease2:"已选择送货时间",
    notUseTime:"没有可选时间",
    deliveryTimeTips:"部分商品我们将与您联系沟通送货时间",
    useTimeRange:"可选日期",
    useTimeRange2:"可选时间",
    orderDetail:"订单明细",
    subtotalGoods: "商品小计",
    promotional: "促销优惠",
    expenses:"配送费用",
    total:"购物车合计",
    submit :"提交订单",
    pickupTips1: "送货",
    pickupTips2: "门店自提",
    pickupTips3: "自提门店",
    pickupTips4: "请选择自提门店",
    pickupTips5: "部分商品我们将与您联系沟通自提时间",
    pickupTips6: "选择",
    pickupTips7: "请选择自提门店！",
    pickupTips8: "预计8-12个工作日，货品到门店后，会有信息通知",
  },
  payment:{
    wxPay: "请使用微信扫码支付",
    wxPaySuccess: "支付成功",
    wxPayCancel: "取消支付",
    cashier:"收银台",
    success:"订单提交成功，请尽快付款",
    orderNo:"订单编号：",
    amount:"待付金额：",
    tips1:"请您在",
    tips2:"内完成支付，否则订单会被自动关闭",
    paymentMethod:"支付方式",
    more :"更多支付方式",
    next :"下一步",
    min: '分',
    sec: '秒'
  },
  coupon:{
    heima:"香港海马牌",
    coupons:"电子优惠券",
    notUsed:"未使用",
    used:"已使用",
    expired:"已过期",
    toUse:"去使用",
    full:"满",
    rebate:"回赠",
    couponMethod:"领取优惠券",
    noCoupon:"暂无优惠券",
    drawSuccess:"领取成功",
    draw:"已领取",
    receive:"领取",
    ranout:"已抢光",
  },
}


//////////////////
// WEBPACK FOOTER
// ./common/lang/cn.js
// module id = /El5
// module chunks = 29